import { Component, OnInit, Input } from '@angular/core';
import { AppCountrySettings } from '../../../BaseFramework/configs'
import { AppOrganizationSettings } from '../../../BaseFramework/configs'
import { AppMetadataHandler } from 'app'

@Component({
  selector: 'app-new-client-capture',
  templateUrl: './new-client-capture.component.html',
  styleUrls: ['./new-client-capture.component.scss']
})
export class NewClientCaptureComponent implements OnInit {

  ngOnInit() {
    this.coc = this.appCountrySettings.currentCountryName;
    this.cob = this.appCountrySettings.currentCountryName;
    this.organizationMetaData = this.appOrganizationSettings.getOrganizationMetaData()

  }

  appCountrySettings = new AppCountrySettings();
  appOrganizationSettings = new AppOrganizationSettings()
  organizationMetaData = null;
  clientRole 
  firstName
  LastName
  gender

  onChange(data){
    
  }

  RolesLookup = []
  list = [
    1, 2, 3
  ]
  date = new Date();
  

  public coc = 'Indonesia'
  public cob = 'Indonesia'

  disabledDate = (current: Date): boolean => {
    // Can not select days before today and today
    // var returnObject = differenceInCalendarYears(current.getFullYear(), this.date.getFullYear()) > 18
    return true;
  };

  inputValue: string;
  filteredOptions = [];
  options = ["Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Anguilla", "Antigua &amp; Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas"
    , "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia &amp; Herzegovina", "Botswana", "Brazil", "British Virgin Islands"
    , "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Chad", "Chile", "China", "Colombia", "Congo", "Cook Islands", "Costa Rica"
    , "Cote D Ivoire", "Croatia", "Cruise Ship", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea"
    , "Estonia", "Ethiopia", "Falkland Islands", "Faroe Islands", "Fiji", "Finland", "France", "French Polynesia", "French West Indies", "Gabon", "Gambia", "Georgia", "Germany", "Ghana"
    , "Gibraltar", "Greece", "Greenland", "Grenada", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea Bissau", "Guyana", "Haiti", "Honduras", "Hong Kong", "Hungary", "Iceland", "India"
    , "Indonesia", "Iran", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kuwait", "Kyrgyz Republic", "Laos", "Latvia"
    , "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macau", "Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Mauritania"
    , "Mauritius", "Mexico", "Moldova", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Namibia", "Nepal", "Netherlands", "Netherlands Antilles", "New Caledonia"
    , "New Zealand", "Nicaragua", "Niger", "Nigeria", "Norway", "Oman", "Pakistan", "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal"
    , "Puerto Rico", "Qatar", "Reunion", "Romania", "Russia", "Rwanda", "Saint Pierre &amp; Miquelon", "Samoa", "San Marino", "Satellite", "Saudi Arabia", "Senegal", "Serbia", "Seychelles"
    , "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "South Africa", "South Korea", "Spain", "Sri Lanka", "St Kitts &amp; Nevis", "St Lucia", "St Vincent", "St. Lucia", "Sudan"
    , "Suriname", "Swaziland", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor L'Este", "Togo", "Tonga", "Trinidad &amp; Tobago", "Tunisia"
    , "Turkey", "Turkmenistan", "Turks &amp; Caicos", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "United States Minor Outlying Islands", "Uruguay"
    , "Uzbekistan", "Venezuela", "Vietnam", "Virgin Islands (US)", "Yemen", "Zambia", "Zimbabwe"];

  constructor(
    public appMetadataHandler: AppMetadataHandler
  ) {
    this.filteredOptions = this.options;
  }

  onInput(value: string): void {
    this.filteredOptions = this.options
      .filter(option => option.toLowerCase().indexOf(value.toLowerCase()) === 0);
  }


  private captureType: string;

  @Input() set captureTypeBroadcastedToChild(value: string) {

    this.captureType = value;
    this.filterRoles(this.captureType);
    //  this.setTitle()

  }

  get captureTypeBroadcastedToChild(): string {

    return this.captureType;

  }

  filterRoles(value) {
    if (value === 'OWNERORPAYER')
      this.RolesLookup = this.AllRolesLookup.filter(role => role.key === 'OWNER' || role.key === 'PAYER' || role.key === 'OWNERPAYER')
    else
      this.RolesLookup = this.AllRolesLookup.filter(role => role.key != 'OWNER' && role.key != 'PAYER' && role.key != 'OWNERPAYER')
  }

  AllRolesLookup = [
    {
      key: 'OWNER',
      value: 'Owner'
    },
    {
      key: 'PAYER',
      value: 'Payer'
    },
    {
      key: 'PRIMARYINSURED',
      value: 'Primary Insured'
    },
    {
      key: 'INSURED',
      value: 'Insured'
    },
  ]

  getRoleDescription(key){
    let matched = this.AllRolesLookup.filter(role => role.key === key)
    return matched[0].value;
  }

}
